<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="activity"
          class="container-fluid menu-margin-top"
          style="padding-left:0px;padding-right:0px"
        >
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>{{ headerMessage }}</b>
              </span>
            </nav>
            <div>
              <button
                type="button"
                @click="setMyDateToToday"
                style="width:3%;margin-right:1%"
                class="btn-blue-save"
              >
                <
              </button>

              <label>Start Of Week</label>

              <label style="margin-left:1.5%">{{
                task.weekStart | moment("MM/DD/YYYY")
              }}</label>

              <label style="margin-left:3%">End Of Week</label>

              <label style="margin-left:1.5%">{{
                task.weekEnd | moment("MM/DD/YYYY")
              }}</label>

              <button
                type="button"
                @click="addADayToMyDate"
                style="width:3%;margin-left:1%"
                class="btn-blue-save"
              >
                >
              </button>
            </div>
            <!--row end-->
            <div
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
            >
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label class="col-form-label col-form-label-sm"
                  >Salesperson Name</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
              >
                <select
                  v-if="this.disableemployeedd"
                  data-vv-name="Employee"
                  v-validate="'required'"
                  class="form-control input-sm"
                  v-model.trim="task.empId"
                  disabled
                >
                  <option
                    selected
                    v-for="emp in employeelist"
                    v-bind:value="emp.employeeId"
                    v-bind:key="emp.employeeId"
                    >{{ emp.firstName }},{{ emp.lastName }}</option
                  >
                </select>
               <!-- <select
                  v-else
                  v-model="selectedName"
                  @[change]="displayTasks"
                  class="form-control input-sm"
                >
                  <option disabled value>Select</option>
                  <option value="All">All</option>
                  <option
                    v-for="employee in employeelist"
                    :value="employee.employeeId"
                    >{{ employee.firstName }},{{ employee.lastName }}</option
                  >
                </select>-->
                <multiselect
    style="width:100%"
    v-else
    v-model="selectedName"
    @input="displayTasks"
    :options="employeelist"
    placeholder="Select Employee"
   :value="employeelist.employeeId"
    :custom-label="displayFullName"
    selected="selected"
    id="statesdd">
    <div slot="beforeList">

                               <span  @click="selectAllOption">All</span>
                            </div>
  </multiselect>
              </div>
            </div>
            <div class="row mt-2 justify-content-center mb-5">
              <div class="col">
                <div
                  class="table-responsive-sm table-responsive-sm mb-5 tbl-update-dealer"
                >
                  <v-table
                    id="tasklist"
                    :data="taskList"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead
                      class="table-month-header-blue wrap-text"
                      slot="head"
                    >
                      <v-th sortKey="startOfWeek">Schedule Week</v-th>
                      <v-th sortKey="employee.firstName">Salesperson Name</v-th>
                      <v-th sortKey="activityTaskX">Activity Task</v-th>
                      <v-th sortKey="dealerName">Dealer Name</v-th>
                      <v-th sortKey="eventType">Event Type</v-th>
                      <v-th sortKey="shortNotes">Short Note</v-th>
                      <v-th sortKey="agentTaskId">Action</v-th>
                    </thead>

                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr v-for="tasks in displayData">
                        <td>
                          {{ tasks.startOfWeek | moment("MM/DD/YYYY") }} to
                          {{ tasks.endOfWeek | moment("MM/DD/YYYY") }}
                        </td>
                        <td>
                          {{ tasks.employee.firstName }},{{
                            tasks.employee.lastName
                          }}
                        </td>
                        <td>{{ tasks.activityTaskX }}</td>
                        <td>{{ tasks.dealerName }}</td>
                        <td>{{ tasks.eventType }}</td>
                        <td>{{ tasks.agentTaskNotes }}</td>
                        <td>
                          {{
                            tasks.lastUpdatedD | moment("MM/DD/YYYY hh:mm:ss")
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpemployee from '../js/http-employee'
import httptask from '../js/http-addtask.js'
import moment from 'moment'
import util from '../js/common-utils'
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  data () {
    return {
      // norecordsfound:'true',
      disableemployeedd: 'false',
      headerMessage: 'View Task',
      name: '',
      users: [],
      employeelist: [],
      selectedName: { 'employeeId': 'All', 'firstName': 'All', 'inactiveD': null, 'lastName': null, 'middleName': null, 'userRoleC': null, 'userRoleX': 'Back Office' },
      taskList: [],
      task: this.initializedata(),
      datas: [
        'Schedule Week',
        'Salesperson Name',
        'Activity Task',
        'Dealer Name',
        'Event Type',
        'Notes',
        'Task Updated Date'
      ]
    }
  },
  methods: {
    displayFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    initializedata () {
      return {
        weekStart: moment().weekday(0),
        weekEnd: moment().weekday(6),
        empId:
          this.$session.get('user_role') == 'SR'
            ? this.$session.get('employee_id')
            : ''
      }
    },
    // subtract week
    setMyDateToToday () {
      this.newdate = moment(this.task.weekStart).subtract('days', 7)
      this.task.weekStart = this.newdate
      this.newdate = moment(this.task.weekEnd).subtract('days', 7)
      this.task.weekEnd = this.newdate
      if (this.$session.get('user_role') == 'SR') {
        this.retriveSalesRepData()
      } else {
        this.displayTasks()
      }
    },

    // adding week
    addADayToMyDate () {
      this.newdate = moment(this.task.weekStart).add('days', 7)
      this.task.weekStart = this.newdate
      this.newdate = moment(this.task.weekEnd).add('days', 7)
      this.task.weekEnd = this.newdate
      if (this.$session.get('user_role') == 'SR') {
        this.retriveSalesRepData()
      } else {
        this.displayTasks()
      }
    },
    // get employeelist
    retriveemployee: function () {
      httpemployee
        .get('/employee')
        .then(response => {
          this.employeelist = response.data
          // console.log("employee details:"+this.employeelist);
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    retriveSalesRepData: function () {
      if (this.$session.get('user_role') == 'SR') {
        httptask
          .get('/employee/' + this.$session.get('employee_id'))
          .then(response => {
            // console.log("Search Results:"+ JSON.stringify(response.data))
            if (response.data.length != 0) {
              // this.norecordsfound = false;
              var viewTaskPayload = {
                repId: this.$session.get('employee_id'),
                fromDate: util.formatDateMoment(this.task.weekStart),
                toDate: util.formatDateMoment(this.task.weekEnd)
              }
              httptask.post('/searchtasks', viewTaskPayload).then(response => {
                this.taskList = response.data
                this.selectedRadio = ''
                this.selectedTask = []
                console.log(
                  'Activity to be saved:' + JSON.stringify(this.tasklist)
                )
              })
            } else {
              // this.norecordsfound = true;
              this.taskList = []
            }
          })
          .catch(e => {
            console.log('Failed to get Tasks for Sales Rep')
            // this.norecordsfound = true;
            this.taskList = []
          })
      } else {
        this.displayTasks()
      }
    },

    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#activity').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
      console.log(txt)
    },

    fetchdata: function () {
      if (this.$session.get('user_role') == 'SR') {
        // console.log("username"+ this.$session.get("user_role") )
        this.employeelist = [
          {
            employeeId: this.$session.get('employee_id'),
            firstName: this.$session.get('first_name'),
            lastName: this.$session.get('last_name')
          }
        ]
        this.task.empId = this.$session.get('employee_id')

        // disable the Dropdown
        this.disableemployeedd = true
      } else {
        this.disableemployeedd = false
        // create objet
        let searchEmployee = {
          firstName: '',
          lastName: '',
          roleType: '', // All Employees
          statusCode: ''
        }
        httpemployee
          .post('/employee/search/', searchEmployee)
          .then(response => {
            this.employeelist = response.data
          })
          .catch(e => {
            console.log('Failed to load salesperson:' + e)
          })
      }

      this.retriveemployee()
      this.retriveSalesRepData()
    },
    selectAllOption () {
      var viewTaskPayload = {
        fromDate: util.formatDateMoment(this.task.weekStart),
        toDate: util.formatDateMoment(this.task.weekEnd)
      }
      httpaddtask.post('/searchtasks', viewTaskPayload).then((response) => {
        this.taskList = response.data
        this.selectedRadio = ''
        this.selectedTask = []
        this.selectedName = { 'employeeId': 'All', 'firstName': 'All', 'inactiveD': null, 'lastName': null, 'middleName': null, 'userRoleC': null, 'userRoleX': 'Back Office' }
        // console.log("Activity to be saved:"+ JSON.stringify( this.tasklist))
      })
    },

    displayTasks: function () {
      if (this.selectedName.employeeId == 'All') {
        var viewTaskPayload = {
          fromDate: util.formatDateMoment(this.task.weekStart),
          toDate: util.formatDateMoment(this.task.weekEnd)
        }
      } else {
        var viewTaskPayload = {
          repId: this.selectedName.employeeId,
          fromDate: util.formatDateMoment(this.task.weekStart),
          toDate: util.formatDateMoment(this.task.weekEnd)
        }
      }
      httptask.post('/searchtasks', viewTaskPayload).then(response => {
        this.taskList = response.data
        // console.log("Activity to be saved:"+ JSON.stringify( this.tasklist))
      })
    }
  },

  computed: {},
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },

  mounted: function () {
    this.fetchdata()
    this.myFunction()
    this.menuheight()
  }
}
</script>
<style scoped></style>
